(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["reservation-signup"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-notify-success]').forEach(function(msg) {
    setTimeout(function() {
      msg.style.transition = 'opacity 0.5s ease';
      msg.style.opacity = '0';
      setTimeout(function() {
        var group = msg.closest('form').querySelector('.email-signup__input-group--success-hidden');
        msg.remove();
        if (group) {
          group.classList.remove('email-signup__input-group--success-hidden');
          group.style.opacity = '0';
          group.style.transition = 'opacity 0.5s ease';
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              group.style.opacity = '1';
            });
          });
        }
      }, 500);
    }, 3000);
  });
  } catch(e) { console.error(e); }
})();

})();
